import * as types from 'types/support';

export const openIntercomChatWindow = (title, requestId) => ({
  payload: { title, requestId },
  type: types.OPEN_INTERCOM_CHAT_WINDOW,
});
